<template>
  <div class="empty-state py-5 text-center">
    <h2 class="mb-4">No hackathons found.</h2>

    <p class="is-marginless">
      <a href="#" @click.prevent="clearQuery" v-if="queryPresent">
        Clear search
      </a>

      <template v-if="queryPresent && anySelectedFilters">
        or
      </template>

      <a href="#" @click.prevent="clearFilters" v-if="anySelectedFilters">
        Clear filters
      </a>
    </p>
  </div>

  <div class="pt-7 hackathons-container" v-if="anyFeaturedHackathons">

    <h3 class="text-center mb-5">
      Featured hackathons
    </h3>

    <hackathon-result
      v-for="hackathon in featuredHackathons"
      :hackathon="hackathon"
      :key="hackathon.id"
      class="mb-5">
    </hackathon-result>
  </div>
</template>

<script>
  import { computed } from 'vue';
  import { useStore } from 'vuex';

  import HackathonResult from '@/components/HackathonResult.vue';

  export default {
    name: "HackathonEmptyState",

    components: {
      HackathonResult
    },

    setup() {
      const store = useStore();

      const featuredHackathons = computed(() => store.getters["hackathons/getFeaturedHackathons"]);

      return {
        queryPresent: computed(() => !!store.getters['filters/getLastSearchQuery']),

        anySelectedFilters: computed(() => store.getters['filters/selectedFilterItemCount'] !== 0),

        clearFilters() {
          store.dispatch("filters/clearFilters");
          store.dispatch("hackathons/search");
        },
        clearQuery() {
          store.dispatch("filters/clearQuery");
          store.dispatch("hackathons/search");
        },

        featuredHackathons,

        anyFeaturedHackathons: computed(() => featuredHackathons.value.length > 0)
      }
    }
  }
</script>

<style scoped lang="scss">
  @import 'colors';

  .empty-state {
    background: $grey-1;
    border: 1px solid $blue-grey-3;
    border-radius: 3px;
  }
</style>
